import { inject } from "vue";
import { b as breadcrumbPluginKey } from "../../../keys-41Cw9q6f.mjs";
const useBreadcrumb = () => ({ ...inject(breadcrumbPluginKey) });
export {
  useBreadcrumb
};
//# sourceMappingURL=index.mjs.map
